<template>
  <div v-if="windowWidth > tabletDisplayPixels" class="landing-background" id="bg" ref="bg">
    <transition name="fade">
      <video v-if="hovered" autoplay muted loop id="backgroundVideo" :key="videoUrl">
        <source ref="backgroundVideoSource" :src="videoUrl" type="video/mp4">
      </video>
    </transition>
    <div class="left-div" @mouseenter="setBgVideo(sides.left)" @mouseleave="setBgVideo()" @click="redirectToDrc()">
      <div class="landing-content">
        <h1>Digital Reference Catalogue</h1>
        <div class="landing-text">{{ $t('landingPage.drcDescription') }}
        </div>
        <transition name="fade">
          <button v-if="hovered === sides.left">{{
              $t('landingPage.exploreDrc').toUpperCase()
            }}
          </button>
        </transition>
      </div>
    </div>
    <div class="divider"></div>
    <div class="right-div" @mouseenter="setBgVideo(sides.right)" @mouseleave="setBgVideo()" @click="redirectToGop()">
      <div class="landing-content">
        <h1>Group Offer Portfolio</h1>
        <div class="landing-text">{{ $t('landingPage.gopDescription') }}
        </div>
        <transition name="fade">
          <button v-if="hovered === sides.right">{{ $t('landingPage.exploreGop').toUpperCase() }}</button>
        </transition>
      </div>
    </div>
    <Newsletter/>
    <div class="landing-backdrop"></div>
  </div>
  <div v-else>
    <MobileLanding/>
  </div>
</template>
<script>
import Newsletter from "@/common/pages/landing/Newsletter.vue";
import MobileLanding from "@/common/pages/landing/MobileLanding.vue";
import * as SERVICES from "@/common/services/common-request-service";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service"

export default {
  name: "Landing",
  components: {MobileLanding, Newsletter},
  data() {
    return {
      windowWidth: window.innerWidth,
      tabletDisplayPixels: 1024,
      videoUrl: '',
      hovered: null,
      sides: {
        left: "left",
        right: "right"
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    this.setBgPicture();
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
      this.setBgPicture();
    },
    setBgPicture(){
      if(this.windowWidth > this.tabletDisplayPixels){
				let imgUrl = require(`@/common/assets/images/landing-page-background.webp`);
        this.$nextTick(() => {
					SERVICES.getLandingPageBackgroundImage()
						.then((response) => imgUrl = response.data)
						.catch((error) => console.error(error))
						.finally(() => this.setImage(imgUrl))
        })
      }
    },
    setImage(img){
      if(this.$refs.bg){
        this.$refs.bg.style.backgroundImage = `url(${img})`;
      }else{
				let elementById = document.getElementById('bg');
				if (elementById) {
					elementById.style.backgroundImage = `url(${img})`;
				}
      }
    },
    setBgVideo(side) {
      if (side === this.sides.left) {
        this.hovered = side;
        this.videoUrl = require('@/common/assets/videos/drc-video.mp4');
        this.$refs?.backgroundVideoSource?.setAttribute('src', this.videoUrl);
      } else if (side === this.sides.right) {
        this.hovered = side;
        this.videoUrl = require('@/common/assets/videos/gop-video.mp4');
        this.$refs?.backgroundVideoSource?.setAttribute('src', this.videoUrl);
      } else {
        this.hovered = false;
      }
    },
    redirectToDrc() {
			STATISTIC_SERVICE.addDrcStatistic({
				action: "LANDING_PAGE_DRC_PLATFORM",
				comment: JSON.stringify({previous_route: STATISTIC_SERVICE.getPreviousRoute()})
			})
      this.$router.push('/home');
    },
		redirectToGop() {
			STATISTIC_SERVICE.addDrcStatistic({
				action: "LANDING_PAGE_GOP_PLATFORM",
				comment: JSON.stringify({previous_route: STATISTIC_SERVICE.getPreviousRoute()})
			})
			this.$router.push('/gop/home');
		}
  }
};
</script>
<style lang="scss">
#app.landing-page{
  height: 100dvh;
  position: relative;
  .main-content{
    max-height: none;
  }
  .landing-page-header{
    pointer-events: none;
    .language-container{
      pointer-events: all;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.landing-backdrop {
  position: absolute;
  width: 100vw;
  height: 12vh;
  background: none;
  bottom: 0;
  left: 0;
}

.landing-background {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  #backgroundVideo {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.5s ease-in-out;
  }

  button {
    position: relative;
    border: none;
    padding: 1.5vh 1.5vw;
    color: $color-black;
    font-weight: bold;
    font-size: 2vh;
    margin-top: 3vh;
    cursor: pointer;
    transition: all 0.5s ease-in-out;
    text-transform: capitalize;

    &:after {
      content: '';
      position: absolute;
      width: 2.5vh;
      height: 2.5vh;
      top: -1vh;
      left: -1vh;
      cursor: default;
      transform: rotate(45deg);
    }
  }

  h1 {
    font-family: Tiempos Text,serif;
    font-size: 5vh;
    font-weight: 400;
    line-height: 6vh;
    letter-spacing: 0.3px;
    text-align: left;
    min-height: 12vh;
    word-break: break-word;
  }

  .landing-text {
    font-family: Roboto,serif;
    font-size: 2.5vh;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.35px;
    text-align: left;
    color: $landing-text-color;
    height: 10vh;
  }

  .left-div {
    top: 0;
    width: 100%;
    height: 150vh;
    transform: rotate(14deg);
    flex: 2;
    transition: all 1s ease-in-out;
    position: relative;
    margin-top: -20vh;
    margin-left: -20vw;
    margin-right: 1vw;
    cursor: pointer;

    .landing-content {
      margin-left: 25vw;
    }

    button {
      background: linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 9%, rgba(255, 184, 28, 1) 9%, rgba(255, 184, 28, 1) 100%);
    }
  }

  .right-div {
    top: 0;
    width: 100%;
    height: 150vh;
    transform: rotate(14deg);
    flex: 2;
    transition: all 1s ease-in-out;
    position: relative;
    margin-top: -20vh;
    margin-right: -20vw;
    margin-left: 1vw;
    cursor: pointer;

    .landing-content {
      margin-right: 25vw;
      padding-top: 2vh;
    }

    button {
      background: linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 9%, rgba(0, 255, 255, 1) 9%, rgba(0, 255, 255, 1) 100%);
    }
  }

  .landing-content {
    transform: rotate(-14deg);
    margin: 50vh 20% 30vh 20%;
    border: none;
    height: 40vh;
  }

  .left-div:hover, .right-div:hover {
    flex: 3;
    transition: all 1s ease-in-out;

    .landing-text {
      color: $color-white-light;
    }
  }

  .left-div:hover {
    background: linear-gradient(301.27deg, rgba(255, 184, 28, 0.56) 16.95%, rgba(255, 255, 255, 0) 36.85%);
    margin-right: 1.25vw;

    h1 {
      color: $color-hover-button;
    }
  }

  .right-div:hover {
    background: linear-gradient(45.13deg, rgba(0, 255, 255, 0.68) 7.21%, rgba(0, 0, 0, 0) 57.03%);
    margin-left: 1.27vw;

    h1 {
      color: $gop-blue;
    }
  }

  .divider {
    width: 1.5px;
    height: 150vh;
    background: $color-white-light;
    transform: rotate(14deg);
    margin-top: -20vh;
  }

  img {
    position: absolute;
  }
}
</style>
